import { render } from "./CardWrap.vue?vue&type=template&id=4efc5f52&scoped=true"
const script = {}

import "./CardWrap.vue?vue&type=style&index=0&id=4efc5f52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efc5f52"]])

export default __exports__